module.exports = __webpack_public_path__ + "static/img/46.e9ac968c.gif";